module.exports = __webpack_public_path__ + "static/media/mesa-tutorial-capa.fa3bd711.webp";